import React, { useState, useMemo, useEffect, useContext } from "react";
import TableStyle from "components/Content/Table/TableStyle.module.css";
import { PrivateRoutesContext } from "app/PrivateRoutesContext";
import TableAllData from "components/Content/CustomTable/TableAllData";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import PeopleOutlinedIcon from '@mui/icons-material/PeopleOutlined';
import HistoryOutlinedIcon from '@mui/icons-material/HistoryOutlined';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import TocOutlinedIcon from '@mui/icons-material/TocOutlined';
import ModalStyles from "components/Content/Modal/ModalStyles.module.css";
import AximTooltip from "components/AximTooltip";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Slide,
    TextField,
    Switch,
    InputAdornment,
    IconButton,
    Autocomplete,
    Grid,
    Link,
    List,
    ListItem,
    ListItemText,
    Typography,
    Divider,
    InputLabel, Select, MenuItem, FormControl
} from "@mui/material";

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
//import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import ButtonStyle from "components/Button/ButtonStyle.module.css";
import { Box } from "@mui/material";
import { apiDelete, apiGet, apiPost } from "app/Services/ApiService";
import { apiUrls } from "common/ApiUrls";
import LoaderAnimation from "pages/LoaderAnimation";
import { Utils } from "common/Utils";
import _ from 'lodash';
import moment from "moment";
import CurrencyFormatter from "components/Formatter/CurrencyFormatter";
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { PropaneSharp } from "@mui/icons-material";
import ContractUsers from "components/Pages/ContractUsers";
import AddContractUserModal from "components/AddContractUserModal";
import dayjs from 'dayjs';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});
export default function ContractMangement(props) {
    const { modalIsOpen, setModalIsOpen, companyId, setCompany, userInfo } = useContext(PrivateRoutesContext);
    const validationSchema = Yup.object().shape({
        contractName: Yup.string().required('Contract Name is required')
            .max(50, 'Contract Name must not exceed 50 characters'),
        contractCode: Yup.string().required('Contract Code is required')
            .max(50, 'Contract Code must not exceed 50 characters'),
        rate: Yup.number().required('Rate is required')
            .min(0, 'Rate cannot be negative'),
        beginDate: Yup.date().default(null)
            .typeError('Invalid begin date')
            .required('Begin Date is required'),
        //.min(dayjs().subtract(1, 'month'), 'Begin Date cannot be ealier than a month of current month'),
        endDate: Yup.date().default(null)
            .required('End Date is required')
            .typeError('Invalid end date')
            .when("beginDate",
                (beginDate, yup) => {
                    if (beginDate instanceof Date && !isNaN(beginDate)) {//invalid date
                        return (beginDate && yup.min(beginDate, "End Date cannot be before Begin Date"))
                    }
                })
    });



    const {
        register,
        control,
        handleSubmit,
        reset,
        setValue,
        setError,
        formState: { errors }
    } = useForm({
        resolver: yupResolver(validationSchema)
    });

    const onSubmit = data => {
        console.dir(contract)
        if (contract.beginDate != null) {
            contract.beginDate = moment(contract.beginDate).toDate()
        }
        if (contract.endDate != null) {
            contract.endDate = moment(contract.endDate).toDate()
        }
        console.dir(contract)
        handleSaveContract()
    };

    const [savingData, setSavingData] = React.useState(false)
    const newContract = {
        "primeSubContractID": Utils.emptyGuid(),
        "contractName": "",
        "contractCode": "",
        "companyID": null,
        "beginDate": null,
        "endDate": null,
        "rate": null,
    };
    const [contract, setContract] = React.useState(newContract);
    const [companyList, setCompanyList] = React.useState([]);
    const [currentCompany, setCurrentCompany] = React.useState('');
    const [currentContract, setCurrentContract] = React.useState(null);
    const [checkingData, setCheckingData] = useState(true);
    const [openModal, setOpen] = useState(false);
    const [openUserModal, setOpenUser] = useState(false);
    const [openSubContractorModal, setOpenSubContractorModal] = useState(false);
    const [columnsArray, setColumnsArray] = useState([]);
    const [fetchedData, setFetchedData] = useState([]);
    const [canEdit, setCanEdit] = useState(props.canEdit ?? true)
    const [assignSubContractor, setAssignSubContractor] = useState(null);
    const [currentSubContractor, setCurrentSubContractor] = useState(null);
    const [subContractList, setSubContractList] = useState([]);
    const [contractUserList, setContractUserList] = useState([]);
    const [loadingContractUsers, setLoadingContractUsers] = useState(false);
    const [openAddUserModal, setOpenAddUserModal] = useState(false);
    const [openHistoryModal, setOpenHistoryModal] = useState(false);
    const [changeHistoryList, setChangeHistoryList] = useState([]);


    useEffect(() => {
        console.log('use effect')
        let selectedCompany = localStorage.getItem(`selectedParentCompanyId`);
        console.log(`selectedCompany ${selectedCompany}`)
        if (selectedCompany == null || selectedCompany === "") {
            setModalIsOpen(true)
        }
        else {
            setCompany(selectedCompany, "Prime")
            console.log(`ready to fetch contracts`)
            fetchContracts(selectedCompany)
            fetchCompanies()
        }
    }, [companyId]);

    const fetchCompanies = () => {
        apiGet(apiUrls.getContractCompanyList)
            .then((response) => {
                console.log('fetch company list')
                console.dir(response)
                setCompanyList(response.data)
            })
            .catch(function (error) {
                // console.log("THIS IS ERROR", error);          

            })
            .then(function () {
                // always executed

            });
    }

    const fetchAssignedSubContractor = (primeSubContractID) => {
        console.log(`primeSubContractID ${primeSubContractID}`)
    }
    const fetchContracts = (companyId) => {
        setCheckingData(true);
        if (companyId == '') {
            let selectedCompany = localStorage.getItem(`selectedParentCompanyId`);
            console.log(`selectedCompany ${selectedCompany}`)
            if (selectedCompany != null && selectedCompany != "") {
                fetchContracts(selectedCompany)
            }
        }
        else {
            apiGet(apiUrls.getCompanyPrimeSubContracts(companyId))
                .then((response) => {
                    console.log('fetch contracts')
                    console.dir(response)
                    setFetchedData(response.data);
                    setCheckingData(false);
                })
                .catch(function (error) {
                    // console.log("THIS IS ERROR", error);          
                    setColumnsArray([]);
                    setFetchedData([]);
                })
                .then(function () {
                    // always executed
                    setCheckingData(false);
                });
        }
    };
    const handleEdit = (contract) => {
        setOpen(true);
        console.log('edit')
        console.log(contract)
        contract.beginDate = moment(contract.beginDate).format("MM/DD/YYYY")
        contract.endDate = moment(contract.endDate).format("MM/DD/YYYY")
        setContract(contract)
        reset(contract)
    }
    const addChildContract = (parentContract) => {
        console.log('parentContract')
        console.log(parentContract)
        let newContract = { ...parentContract }
        console.log(newContract)
        setOpen(true);
        newContract.primeSubContractID = Utils.emptyGuid()
        newContract.parentID = parentContract.primeSubContractID
        newContract.beginDate = moment(parentContract.beginDate).format("MM/DD/YYYY")
        newContract.endDate = moment(parentContract.endDate).format("MM/DD/YYYY")
        setContract(newContract)
        reset(newContract)
    }

    const handleClose = () => {
        setOpen(false);
        //setAnchorEl(null);
    };
    const handleContractUserClose = () => {
        setOpenUser(false);
        //setAnchorEl(null);
    };

    const handleSubContractorClose = () => {
        setOpenSubContractorModal(false);
        //setAnchorEl(null);
    };

    const showSubContractor = (contract) => {
        setOpenSubContractorModal(true);
        console.log('showSubContractor')
        console.log(contract)
        setCurrentContract(contract)


        apiGet(apiUrls.getAssignPrimeSubContract(contract.companyId, contract.primeSubContractID))
            .then((response) => {
                console.log('getAssignPrimeSubContract')
                console.dir(response.data)
                setSubContractList(response.data)
            })
            .catch(function (error) {
            })
            .then(function () {
                setSavingData(false)
            });
        //setAnchorEl(null);
    };
    const showAddModal = () => {
        setContract(newContract);
        setOpen(true);
        reset(newContract)
    };

    const showHistory = (contract) => {
        setOpenHistoryModal(true);
        console.log('showHistory')
        console.log(contract)
        // setCurrentContract(contract)
        apiGet(apiUrls.getPrimeSubContractHistory(contract.companyID, contract.primeSubContractID))
            .then((response) => {
                console.log('getPrimeSubContractHistory')
                console.dir(response.data)
                setChangeHistoryList(response.data)
            })
            .catch(function (error) {
            })
            .then(function () {
                setSavingData(false)
            });
    };
    const handleContractChange = (propName, propValue) => {
        let obj = { ...contract }
        obj[propName] = propValue
        if (propName == 'contractCode') {
            obj['contractCode'] = propValue.replaceAll(' ', '_').substring(0, 50)
        }
        if ((propName == 'beginDate' || propName == 'endDate') && propValue == '') {
            obj[propName] = null
        }

        if ((propName == 'beginDate' && propValue != '')) {
            validationSchema.isValid().then(() => {
                console.log('valid')
                let newEndDate = dayjs(propValue).add(1, 'year').subtract(1, 'day').format('YYYY-MM-DD')
                //handleContractChange('endDate', dayjs(propValue).add(1,'year').subtract(1,'day').format('YYYY-MM-DD'))
                obj['endDate'] = newEndDate
                setValue('endDate', newEndDate, { shouldValidate: false })
            });
        }
        setContract(obj)
        // console.log(propName)
        // console.log(propValue)
        setValue(propName, propValue, { shouldValidate: true })
    };

    const handleSaveContract = () => {
        setSavingData(true)
        console.log('saving contract')
        console.log(companyId)
        console.dir(contract)
        contract.companyID = companyId
        if (contract.companyID == null) {
            contract.companyID = Utils.emptyGuid()
        }
        // let companyId = currentCompany
        apiPost(apiUrls.postPrimeSubContract(companyId), contract)
            .then((response) => {
                fetchContracts(companyId)
                setOpen(false)

                let feedbackData = {
                    feedbackTypeCodeID: 9,//Configuration Inquiries
                    subject: 'Contract update',
                    content: `Contract updated for ${contract.contractName}, please review.`,
                };

                apiPost(apiUrls.postFeedbackForm(companyId), feedbackData)
                    .then((res) => {
                    })
                    .catch((e) => {
                    });
            })
            .catch(function (error) {
                console.log('error')
                console.log(error)
                if (error.response) {
                    console.log(error.response.data);
                    console.log(error.response.status);
                    if (error.response.data == 'date range overlap with other contract rates') {
                        setError('beginDate', { type: 'custom', message: error.response.data })
                        setError('endDate', { type: 'custom', message: error.response.data })
                    }
                    if (error.response.data == 'contract already exists') {
                        setError('contractName', { type: 'custom', message: error.response.data })
                        setError('contractCode', { type: 'custom', message: error.response.data })
                    }
                }
            })
            .then(function () {
                setSavingData(false)
            });
    };

    const assignContractToCompany = () => {
        setSavingData(true)
        console.log('assigning contract to company')
        console.log(companyId)
        console.log(assignSubContractor)
        console.log(currentContract)

        const primeSubContractCompany = {
            statusId: 1,
            companyId: assignSubContractor.value,
            primeSubContractId: currentContract.primeSubContractID,
            beginDate: '1900-01-01',
            endDate: '9999-01-01'
        };
        console.log(`primeSubContractCompany`)
        console.dir(primeSubContractCompany)

        apiPost(apiUrls.assignPrimeSubContract(companyId), primeSubContractCompany)
            .then((response) => {
                console.log('response')
                console.log(response)
                showSubContractor(currentContract)
            })
            .catch(function (error) {
            })
            .then(function () {
                setSavingData(false)
            });
    };

    const getContractUsers = (companyId) => {
        setLoadingContractUsers(true)
        apiGet(apiUrls.getPrimeSubContractUsers(companyId))
            .then((response) => {
                console.log('fetch contract users')
                console.dir(response)
                setContractUserList(response.data)
            })
            .catch(function (error) {
                // console.log("THIS IS ERROR", error)          
                // setColumnsArray([])
                // setFetchedData([])
            })
            .then(function () {
                // always executed
                setLoadingContractUsers(false)
            })
    }

    const showAddUser = () => {
        console.log('showAddUser')
        setOpenUser(true)
        console.log('currentContract')
        console.log(currentContract)
        console.log('currentSubContractor')
        console.log(currentSubContractor)
        setOpenAddUserModal(true)
        //addUserModalRef.current.setOpenUser(true)


    };

    const toggleUserAccess = (user) => {
        console.log('toggle user access')
        console.log(user)
        console.log(currentContract)
        console.log(currentSubContractor)
        if (user.hasAccess) {
            apiDelete(apiUrls.removePrimeSubContractUsers(currentContract.companyID, user.userId, currentContract.primeSubContractID))
                .then((response) => {
                    console.log('delete contract users')
                    console.dir(response)
                    getContractUsers(currentSubContractor.companyID)
                })
                .catch(function (error) {
                    // console.log("THIS IS ERROR", error)          
                    // setColumnsArray([])
                    // setFetchedData([])
                })
                .then(function () {
                    // always executed
                    // setLoadingContractUsers(false)
                })
        }
        else {
            apiPost(apiUrls.grantPrimeSubContractUsers(currentContract.companyID, user.userId, currentContract.primeSubContractID))
                .then((response) => {
                    console.log('grant contract users')
                    console.dir(response)
                    getContractUsers(currentSubContractor.companyID)
                })
                .catch(function (error) {
                    // console.log("THIS IS ERROR", error)          
                    // setColumnsArray([])
                    // setFetchedData([])
                })
                .then(function () {
                    // always executed
                    // setLoadingContractUsers(false)
                })
        }

    }

    const handleCloseAddUserModal = () => {
        setOpenAddUserModal(false)
    }

    useEffect(() => {
        setColumnsArray(columns)
        if (props.canEdit) {
            setCanEdit(props.canEdit)
        }
    }, []);

    useEffect(() => {
        // fetchContracts(companyId)
        //fetchCompanies()
    }, [props.refresh]);

    useEffect(() => {
        if (props.canEdit) {
            setCanEdit(props.canEdit)
        }
    }, [props.canEdit]);


    let columns = [
        {
            Header: "Action",
            accessor: (cell) => (canEdit ?
                <>
                    <AximTooltip title="Edit" disableFocusListener>
                        <IconButton color="primary" aria-label="Edit" component="span"
                            onClick={() => handleEdit(cell)} >
                            <EditOutlinedIcon />
                        </IconButton>
                    </AximTooltip>
                    <AximTooltip title="Company" disableFocusListener>
                        <IconButton color="primary" aria-label="Users" component="span"
                            onClick={() => { showSubContractor(cell) }} >
                            <TocOutlinedIcon />
                        </IconButton>
                    </AximTooltip>
                    <AximTooltip title="History" disableFocusListener>
                        <IconButton color="primary" aria-label="Users" component="span"
                            onClick={() => { showHistory(cell) }} >
                            <HistoryOutlinedIcon />
                        </IconButton>
                    </AximTooltip>
                    <AximTooltip title="Add Rate" disableFocusListener>
                        <IconButton color="primary" aria-label="Users" component="span"
                            onClick={() => { addChildContract(cell) }} >
                            <AddCircleOutlineOutlinedIcon />
                        </IconButton>
                    </AximTooltip>
                </> : <></>),
            disableFilters: true,
            className: (canEdit ? "" : "invisible")
        },
        {
            Header: "Contract Name",
            accessor: "contractName",
        },
        {
            Header: "Contract Code",
            accessor: "contractCode",
        },
        {
            Header: "Begin Date",
            accessor: (cell) => Utils.formatDate(cell.beginDate),
            Cell: ({ row }) => (
                <Box>
                    {Utils.formatDate(row.original.beginDate)}
                </Box>
            ),
            sortType: "dateSort",
        },
        {
            Header: "End Date",
            accessor: (cell) => Utils.formatDate(cell.endDate),
            Cell: ({ row }) => (
                <Box>
                    {Utils.formatDate(row.original.endDate)}
                </Box>
            ),
            sortType: "dateSort",
        },
        {
            Header: "Rate",
            accessor: (cell) => <CurrencyFormatter value={cell.rate} />
        }
    ];

    const options = {
        filter: true,
        filterType: "dropdown",
        responsive: "standard",
        viewColumns: true,
        download: false,
        print: false,
        textLabels: {
            body: {
                noMatch:
                    fetchedData !== undefined ? (
                        <LoaderAnimation />
                    ) : (
                        "Sorry, there is no data to show"
                    ),
            },
        },
        searchProps: { variant: "standard" }
    };


    const parseChanges = (changes) => {
        let changeList = []
        const changeObj = JSON.parse(changes);
        if (changeObj.OldValue == "") {
            // changeList.push(`New`)
            for (const [key, value] of Object.entries(changeObj.NewValue)) {
                if (key != 'UpdateDate' && key != 'UpdateUserName' && key.slice(-2) != "Id"  && key.slice(-2) != "ID") {
                    //console.log(`${key}: ${value}`);
                    if (key.slice(-4) == "Date") {
                        changeList.push(`${_.startCase(key)} : ${Utils.formatDate(value)} `)
                    }
                    else {
                        if (key != 'CreateUserName' ) {
                            changeList.push(`${_.startCase(key)} : ${value??""}`)
                        }
                    }
                }
            }
        }
        if (changes.OldValue != "" && changes.NewValue != "") {
            const oldVal = changeObj.OldValue;
            const newVal = changeObj.NewValue;
            for (const [key, value] of Object.entries(newVal)) {
                if (key != 'UpdateDate' && key != 'UpdateUserName' && key.slice(-2) != "Id" && key.slice(-2) != "ID") {
                    //console.log(`${key}: ${value}`);
                    if (oldVal[key] !== undefined && oldVal[key] != value) {
                        if (key.slice(-4) == "Date") {
                            changeList.push(`${_.startCase(key)} changed from ${Utils.formatDate(oldVal[key])} to ${Utils.formatDate(value)} by ${newVal['UpdateUserName']}`)
                        }
                        else {
                            changeList.push(`${_.startCase(key)} changed from ${oldVal[key]} to ${value}  by ${newVal['UpdateUserName']}`)
                        }
                    }
                }
            }
        }
        return changeList;
    }

    const rednerNotification = (cell) => {
        return <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
            {
                _.uniq(cell.notificationList.map(a => a.emailTemplateDescription)).map(a =>
                    <><ListItem alignItems="flex-start">
                        <ListItemText
                            primary={<Typography
                                sx={{ display: 'inline'}}
                                component="span"
                                variant="subtitle2"
                                color="text.primary"
                            >
                              { a }
                            </Typography>}
                            secondary={
                                cell.notificationList.filter(f => f.emailTemplateDescription == a).map(f => <React.Fragment>
                                    <Typography
                                        sx={{ display: 'inline',paddingLeft: '10px',paddingRight: '10px' }}
                                        component="span"
                                        variant="inset"
                                        color="text.primary"
                                    >
                                      { f.userName }
                                    </Typography>
                                    { f.statusID==0?"Pending":"Sent" }<br/>
                                </React.Fragment>)
                                
                            }
                        />
                    </ListItem>
                        </>
                )
            }
        </List>
        // return <ul>{_.uniq(cell.notificationList.map(a => { return a.emailTemplateDescription })).map(a => <li><AximTooltip title="View Users\n hi<br>ho" disableFocusListener><div>{a}</div></AximTooltip></li>)}</ul>
    }

    const rednerAck = (cell) => {
        return <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
            {
                _.uniq(cell.ackList.map(a => a.statusID)).map(a =>
                    <><ListItem alignItems="flex-start">
                        <ListItemText
                            primary={<Typography
                                sx={{ display: 'inline'}}
                                component="span"
                                variant="subtitle2"
                                color="text.primary"
                            >
                              {a == 1 ? "Pending" : "Acknowledged"}
                            </Typography>}
                            secondary={
                                cell.ackList.filter(f => f.statusID == a).map(f => <React.Fragment>
                                    <Typography
                                        sx={{ display: 'inline',paddingLeft: '10px',paddingRight: '10px' }}
                                        component="span"
                                        variant="inset"
                                        color="text.primary"
                                    >
                                      { f.userName }
                                    </Typography><br/>
                                </React.Fragment>)
                                
                            }
                        />
                    </ListItem>
                        </>
                )
            }
        </List>
        // return <ul>{_.uniq(cell.notificationList.map(a => { return a.emailTemplateDescription })).map(a => <li><AximTooltip title="View Users\n hi<br>ho" disableFocusListener><div>{a}</div></AximTooltip></li>)}</ul>
    }
    const changeHistoryListColumnsArray = [
        {
            Header: "Date",
            accessor: (cell) => Utils.formatDate(cell.createDate),
            style: { width: "150px" },
            cellStyle: { width: "150px" },
        },
        {
            Header: "Change",
            accessor: (cell) => (
                <Box>
                    <ul>{parseChanges(cell.changes).map(c => { return <li>{c}</li> })}</ul>
                </Box>
            ),
            style: { width: "250px" },
            cellStyle: { width: "250px" },
        },
        {
            Header: "Notification",
            accessor: (cell) => (
                <Box>
                    {(cell.requireNotification == 0 ? "" : rednerNotification(cell))}
                </Box>
            ),
            style: { width: "300px" },
            cellStyle: { width: "300px" },
        },
        {
            Header: "Acknowledgement",
            accessor: (cell) => (
                <Box sx={{ minWidth: 250 }}>
                    {(cell.requireAck == 0 ? "" : rednerAck(cell))}
                </Box>
            )
        }
    ];
    const subContractListColumnsArray = [
        {
            Header: "Subcontractor Name",
            accessor: (cell) => (
                <Box>
                    <AximTooltip title="View Users" disableFocusListener>
                        <Link
                            component="button"
                            onClick={(e) => {
                                e.preventDefault()
                                console.dir(cell.companyID);
                                setCurrentSubContractor(cell)
                                getContractUsers(cell.companyID)
                            }}
                        >
                            {cell.companyName}
                        </Link>
                    </AximTooltip>
                </Box>
            ),
        }
    ];

    const subContractUserListColumnsArray = [
        {
            Header: "User",
            accessor: "userName",
        },
        {
            Header: "Action",
            accessor: (cell) =>
                <AximTooltip title="Remove Access" disableFocusListener>
                    <Switch defaultChecked={cell.hasAccess} onClick={() => { toggleUserAccess(cell) }} />
                </AximTooltip>,
            disableFilters: true,
            className: (canEdit ? "" : "invisible")
        }
    ];

    const childContract = (row, rowProps, visibleColumns) => {
        if (row.row.original.children.length == 0) {
            return <></>
        }
        return (
            row.row.original.children.map((c, idx) => {
                return <Grid container>
                    <Grid item sm={7}>
                    </Grid>
                    <Grid item sm={1}>

                        <AximTooltip title="Edit" disableFocusListener>
                            <IconButton color="primary" aria-label="Edit" component="span"
                                onClick={() => handleEdit(c)} >
                                <EditOutlinedIcon />
                            </IconButton>
                        </AximTooltip>
                        <AximTooltip title="History" disableFocusListener>
                            <IconButton color="primary" aria-label="Users" component="span"
                                onClick={() => { showHistory(c) }} >
                                <HistoryOutlinedIcon />
                            </IconButton>
                        </AximTooltip>
                    </Grid>
                    <Grid item sm={4}>
                        <Grid container>
                            <Grid item sm={4}> {Utils.formatDate(c.beginDate)}
                            </Grid>
                            <Grid item sm={4}> {Utils.formatDate(c.endDate)}
                            </Grid>
                            <Grid item sm={4}><CurrencyFormatter value={c.rate} />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            })
        )
    }
    return (
        <>
            {/* Add Contract MODAL */}
            <Dialog
                open={openModal}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleClose}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
                className={TableStyle.fileTypeModalWrapper}
                fullWidth
            >
                <DialogTitle id="alert-dialog-slide-title">
                    {(contract.primeSubContractID == Utils.emptyGuid() ? "Add Contract" : "Edit Contract")}
                </DialogTitle>
                <DialogContent>
                    <Box
                        component="form"
                        sx={{
                            '& .MuiTextField-root': { m: 1, width: '25ch' },
                        }}
                        noValidate
                        autoComplete="off"
                    >
                        <div>

                            <TextField
                                {...register('contractName')}
                                label="ContractName"
                                sx={{ m: 1, width: '25ch' }}
                                required
                                value={contract.contractName}
                                onChange={(e) => handleContractChange('contractName', e.target.value)}
                                id="contractName"
                                name="contractName"
                                variant="standard"
                                error={errors.contractName ? true : false}
                                helperText={errors.contractName?.message}
                                InputProps={contract.parentID != null ? {
                                    readOnly: true,
                                } : {}}
                            />

                            <TextField
                                {...register('contractCode')}
                                label="ContractCode"
                                sx={{ m: 1, width: '25ch' }}
                                required
                                value={contract.contractCode}
                                onChange={(e) => handleContractChange('contractCode', e.target.value)}
                                id="contractCode"
                                name="contractCode"
                                variant="standard"
                                error={errors.contractCode ? true : false}
                                helperText={errors.contractCode?.message}
                                InputProps={contract.parentID != null ? {
                                    readOnly: true,
                                } : {}}
                            />
                        </div>
                        <div>

                            <TextField
                                {...register('rate')}
                                label="Rate"
                                sx={{ m: 1, width: '25ch' }}
                                InputProps={{
                                    startAdornment: <InputAdornment position="start">$</InputAdornment>,
                                }}
                                required
                                value={contract.rate}
                                onChange={(e) => handleContractChange('rate', e.target.value)}
                                id="rate"
                                name="rate"
                                variant="standard"
                                error={errors.rate ? true : false}
                                helperText={errors.rate?.message}
                            />
                        </div>
                        <div>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    {...register('beginDate')}
                                    id="beginDate"
                                    name="beginDate"
                                    minDate={dayjs().subtract(1, 'month')}
                                    //minDate={dayjs('01/01/1990')}
                                    value={dayjs(contract.beginDate)}
                                    onChange={(newValue) => handleContractChange('beginDate', newValue?.format('YYYY-MM-DD'))}
                                    label="Begin Date"
                                    slotProps={{
                                        textField: {
                                            helperText: errors.beginDate?.message,
                                        },
                                    }}
                                />
                            </LocalizationProvider>

                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    {...register('endDate')}
                                    id="endDate"
                                    name="endDate"
                                    minDate={dayjs('01/01/1990')}
                                    value={dayjs(contract.endDate)}
                                    onChange={(newValue) => handleContractChange('endDate', newValue?.format('YYYY-MM-DD'))}
                                    label="End Date"
                                    slotProps={{
                                        textField: {
                                            helperText: errors.endDate?.message,
                                        },
                                    }}
                                />
                            </LocalizationProvider>

                        </div>
                    </Box>
                </DialogContent>
                <DialogActions className={ButtonStyle.buttonWrapper}>
                    <Button
                        variant="outlined"
                        onClick={handleSubmit(onSubmit)}
                        disabled={savingData}
                    >
                        {(savingData ? "Saving" : "Save")}
                    </Button>
                    <Button onClick={handleClose} className={ButtonStyle.CcancelBtn}>
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>


            <>
                {/* Assign Company MODAL */}
                <Dialog
                    open={openSubContractorModal}
                    TransitionComponent={Transition}
                    keepMounted
                    onClose={handleSubContractorClose}
                    aria-labelledby="alert-dialog-slide-title"
                    aria-describedby="alert-dialog-slide-description"
                    className={TableStyle.fileTypeModalWrapper}
                    fullWidth
                    maxWidth="lg"            >
                    <DialogTitle id="alert-dialog-slide-title">
                        {currentContract?.contractName}
                    </DialogTitle>
                    <DialogContent>
                        <Box
                            component="form"
                            sx={{
                                '& .MuiTextField-root': { m: 1, width: '25ch' },
                            }}
                            noValidate
                            autoComplete="off"
                        >
                            <div>
                                <Grid container spacing={2}>
                                    <Grid item xs={4}>
                                        <Autocomplete
                                            value={assignSubContractor}
                                            onChange={(event, newValue) => {
                                                setAssignSubContractor(newValue);
                                            }}
                                            disablePortal
                                            id="combo-box-demo"
                                            options={companyList.map((val, i) => { return { label: val.companyName, value: val.companyId } })}
                                            renderInput={(params) => <TextField {...params} label="Subcontractor" />}
                                        />
                                    </Grid>
                                    <Grid item xs={8}>
                                        <Button onClick={assignContractToCompany} className={ButtonStyle.CcancelBtn}
                                            sx={{ m: 1, width: '25ch' }}>
                                            Assign
                                        </Button>
                                    </Grid>
                                </Grid>
                            </div>
                            <div>

                                <Grid container spacing={2}>
                                    <Grid item xs={6}>
                                        <TableAllData
                                            className={TableStyle.TimeSheetsWrapper}
                                            columns={subContractListColumnsArray}
                                            data={subContractList}
                                            hideFilter={true}
                                            hidePagination={true}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        {currentSubContractor ?
                                            <TableAllData
                                                className={TableStyle.TimeSheetsWrapper}
                                                columns={subContractUserListColumnsArray}
                                                data={contractUserList}
                                                hidePagination={true}
                                                isLoading={loadingContractUsers}
                                                headerContents={<>
                                                    {currentSubContractor.companyName}
                                                    <AximTooltip title="Add User" disableFocusListener>
                                                        <IconButton color="primary" aria-label="Users" component="span" sx={{ minWidth: 100 }}
                                                            onClick={showAddUser} >
                                                            <PeopleOutlinedIcon />
                                                        </IconButton>
                                                    </AximTooltip>
                                                </>}
                                            /> : <></>}
                                    </Grid>
                                </Grid>

                            </div>
                        </Box>
                    </DialogContent>
                    <DialogActions className={ButtonStyle.buttonWrapper}>
                        <Button onClick={handleSubContractorClose} className={ButtonStyle.CcancelBtn}>
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>
            </>
            {/* History Modal */}
            <Dialog
                open={openHistoryModal}
                TransitionComponent={Transition}
                keepMounted
                onClose={() => { setOpenHistoryModal(false) }}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
                className={TableStyle.fileTypeModalWrapper}
                fullWidth
                maxWidth="lg"            >
                <DialogTitle id="alert-dialog-slide-title">
                    {currentContract?.contractName}
                </DialogTitle>
                <DialogContent>
                    <Box
                        component="form"
                        sx={{
                            '& .MuiTextField-root': { m: 1, width: '25ch' },
                        }}
                        noValidate
                        autoComplete="off"
                    >
                        <div>
                            <TableAllData
                                className={TableStyle.TimeSheetsWrapper}
                                columns={changeHistoryListColumnsArray}
                                data={changeHistoryList}
                                hideFilter={true}
                                hidePagination={true}
                                theadStyles={{ display: "block" }}
                                tbodyStyles={{ display: "block", height: "400px", overflowY: "auto" }}
                            />
                        </div>
                    </Box>
                </DialogContent>
                <DialogActions className={ButtonStyle.buttonWrapper}>
                    <Button onClick={() => { setOpenHistoryModal(false) }} className={ButtonStyle.CcancelBtn}>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
            {openAddUserModal ? <AddContractUserModal
                companyId={currentSubContractor.companyID}
                handleCloseUser={() => {
                    console.log('close');
                    setOpenAddUserModal(false)
                }}
                refreshUsers={() => {
                    getContractUsers(currentSubContractor.companyID)
                }}
            >
            </AddContractUserModal> : <></>}


            <TableAllData
                className={`${TableStyle.TimeSheetsWrapper}`}
                columns={columnsArray}
                data={fetchedData}
                renderRowSubComponent={childContract}
                isAlwaysExpanded={true}
                headerContents={<>
                    {canEdit ? <AximTooltip title="Add Contract" disableFocusListener >
                        <IconButton color="primary" aria-label="Add Contract" component="span" sx={{ minWidth: 100 }}
                            onClick={showAddModal} >
                            <AddCircleOutlineOutlinedIcon />
                        </IconButton>
                    </AximTooltip> : <></>}


                    <FormControl sx={{ m: 1, minWidth: 150 }}
                        className={ModalStyles.cField}>
                        <InputLabel>Company</InputLabel>
                        <Select
                            id="companyID"
                            name="companyID"
                            label="Company"
                            value={currentCompany}
                            required
                            shrink
                            size="small"
                            variant="standard"
                            onChange={(e) => { setCurrentCompany(e.target.value); fetchContracts(e.target.value) }}
                        >
                            <MenuItem value={''} key={-1}>All</MenuItem>
                            {companyList.map((val, i) => <MenuItem value={val.companyId} key={i}>{val.companyName}</MenuItem>)}

                        </Select>
                    </FormControl>
                </>}
            />
        </>
    )
}